import { LazyLoading } from "@/controls/LazyLoading";
import { FailedStartup } from "@/pages/caster/failed-startup";
import { ChemistryHeatReportPage } from "@/pages/laboratory/chemistry-heat-report/ChemistryHeatReportPage";
import { LabDataEntryPage } from "@/pages/laboratory/data-entry/LabDataEntryPage";
import { CasterHeatReportProvider } from "@/pages/meltshop/heat-report/HeatReportContext";
import * as React from "react";
import { Suspense } from "react";
import { Route } from "react-router-dom";
import CasterCounters from "../../pages/caster/caster-counters";
import CasterDataEntryV2 from "../../pages/caster/caster-data-entry-v2";
import CasterProcesses from "../../pages/caster/caster-processes";
import ProductionManagement from "../../pages/caster/production-management";
import CasterProduction from "../../pages/caster/production/CasterProduction";

export const CasterRoutes = [
	<Route
		path="/caster-data-entry"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<CasterDataEntryV2 />
			</Suspense>
		}
	/>,
	<Route
		path="/caster-data-entry/:processId"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<CasterDataEntryV2 />
			</Suspense>
		}
	>
		{" "}
	</Route>,
	<Route
		path="/caster-production"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<CasterProduction />
			</Suspense>
		}
	/>,
	<Route
		path="/caster-processes"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<CasterProcesses />
			</Suspense>
		}
	/>,
	<Route
		path="/caster-processes/:shiftId"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<CasterProcesses />
			</Suspense>
		}
	/>,
	<Route
		path="/caster-counters"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<CasterCounters />
			</Suspense>
		}
	/>,
	<Route
		path="/caster-counters/:shiftId"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<CasterCounters />
			</Suspense>
		}
	/>,
	<Route
		path="/failed-startups"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<FailedStartup />
			</Suspense>
		}
	/>,
	<Route
		path="/production-management"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<ProductionManagement />
			</Suspense>
		}
	/>,
	<Route
		path="/production-management/:shiftId"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<ProductionManagement />
			</Suspense>
		}
	/>,

	<Route path="/lab-data-entry" element={<CasterHeatReportProvider />}>
		<Route
			index
			element={
				<Suspense fallback={<LazyLoading></LazyLoading>}>
					<LabDataEntryPage />
				</Suspense>
			}
		/>
		<Route
			path=":heatName"
			element={
				<Suspense fallback={<LazyLoading></LazyLoading>}>
					<LabDataEntryPage />
				</Suspense>
			}
		/>
	</Route>,

	<Route path="/heat-report/chemistry" element={<CasterHeatReportProvider />}>
		<Route
			index
			element={
				<Suspense fallback={<LazyLoading></LazyLoading>}>
					<ChemistryHeatReportPage />
				</Suspense>
			}
		/>
		<Route
			path=":heatName"
			element={
				<Suspense fallback={<LazyLoading></LazyLoading>}>
					<ChemistryHeatReportPage />
				</Suspense>
			}
		/>
	</Route>,
];
